<template>
	<inertia-head title="BOSS - Bo's Strategic Stocks" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">BOSS <span v-if="bossStocks">FOR {{bossStocks[0].boss_month}} {{bossStocks[0].boss_year}}</span></h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Make smarter investing decisions with BOSS! Brother Bo's Strategic Stocks are specifically hand-selected to help you make the most of your money. Whether you're a beginner or an experienced investor, BOSS can provide you with the research and insight you need to grow your portfolio with confidence. With BOSS, you get Brother Bo's personal touch and expertise for your investments - start investing today!
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div v-if="user.current_rank === 'SILVER'">
				<div class="alert alert-warning">
					<p class="mb-0 fw-semibold">
							UPGRADE to GOLD or HIGHER to view BOSS Recomendations.
					</p>
				</div>
	</div>
	<div v-else>
	<div class="block">
		<div class="block-content block-content-full">
			
			
			<div class="row justify-content-center">
				<div v-for="(boss,b_index) in bossStocks" class="col-md-3">
					<img :src="boss.company_logo_url" class="img img-fluid" />
				</div>
			</div>
		</div>
		
	</div>

	<div class="content">
		<div class="block block-rounded">
			<div class="block-content block-content-full">
				
				
					<div class="table-responsive">
						<table class="table table-striped table-borderless table-hover table-vcenter fs-sm">
							<thead>
								<tr>
									<th>#</th>
									<th>Stocks</th>
									<th>Current Price</th>
									<th>Buy Below Price</th>
									<th>Target Price</th>
									<th>Expected Growth</th>
									<th>Max%</th>
									<th>% From Target Price</th>
									<th>Recommendation</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(stock,s_index) in bossStocks">
									<td>{{s_index+1}}</td>
									<td nowrap="">
										<inertia-link v-if="stock.has_details>0" href="#" @click="viewDetails(stock.stock)" class="fw-bold text-info" title="View the details">{{stock.stock}}</inertia-link>
										<inertia-link v-if="stock.has_details<=0" href="#" class="fw-bold text-secondary" title="No Details">{{stock.stock}}</inertia-link>
									</td>
									<td>{{stock.tradeprice}}</td>
									<td>{{stock.buybelowprice}}</td>
									<td>{{stock.targetprice}}</td>
									<td>{{stock.expected_growth}}</td>
									<td>{{stock.maxperc}}</td>
									<td>{{stock.target_percent}}</td>
									<td class="text-end">
										<span class="fw-semibold" 
											:class="{
												'text-success':stock.actiontotake=='Continue Buying',
												'text-danger':stock.actiontotake=='Stop Buying',
												'text-elagance':stock.actiontotake=='Sell',
												'text-warning':stock.actiontotake=='Hold'
											}"
											>
											<small>{{stock.actiontotake}}</small>
										</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				
			</div>
		</div>

		<div v-if="announcement" class="block block-rounded">
			<div class="block-content block-content-full">
				<h4>{{announcement.title}}</h4>
				<div class="fs-sm mt-4" style="white-space: pre; white-space:break-spaces;" v-html="announcement.description"></div>
			</div>
			<div v-if="prevBoss.length>0" class="block-content block-content-full">
				<h5>Previous BOSS Recommendations</h5>
				<p class="text-danger fs-sm">Important Note: All BOSS recommendations are time-sensitive. It is best to buy them during the months we announce it.</p>
				<ul>
					<li v-for="(prev,p_index) in prevBoss">
						<a @click="selectPrevBoss(p_index)" href="javascript:void(0)">
							{{prev.title}}		
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</div>


	<modal ref="prevBossModal" size="modal-xl">
		<template #title>PREVIOUS BOSS RECOMMENDATION</template>
		<template #body>
			<div>
				<h5>{{selectedBoss.title}}</h5>
				<div class="fs-sm mt-4" style="white-space: pre; white-space:break-spaces;" v-html="selectedBoss.description"></div>
			</div>
		</template>
		<template #footer>
			<button @click="prevBossModal.toggleModal()" type="button" class="btn btn-alt-secondary">
				Close
			</button>
		</template>
	</modal>


	<recommendations-modal
	ref="recommendationsModal"
	:stockDetails="stockDetails"
	></recommendations-modal>

</template>

<script>

	window.dataLayer = window.dataLayer || [];
	function gtag(){dataLayer.push(arguments);}
	gtag('js', new Date());

	gtag('config', window.gtag_id);

	import { onMounted, ref, reactive, watch } from 'vue';
	import { Inertia } from '@inertiajs/inertia';
	import AuthLayout from '../../../Layouts/AuthLayout';
	import RecommendationsModal from '../../../Components/Member/RecommendationsModal';

	export default{
		layout: AuthLayout,
		props:{
			user			: Object,
			bossStocks 		: Object,
			announcement 	: Object,
			prevBoss 		: Object,
			stockDetails	: Object,
			api_response 	: Object,
		},
		components:{RecommendationsModal},
		setup(props) {

			onMounted(() => {
				const pageContainer = document.getElementById('page-container')
				if (pageContainer.classList.contains('sidebar-o-xs'))
					pageContainer.classList.remove('sidebar-o-xs')
			})

			const recommendationsModal 	= ref(null);
			const prevBossModal 		= ref(null);

			const selectedBoss 			= reactive({});

			const selectPrevBoss 		= (index)=>{
				let data = props.prevBoss[index];

				Object.assign(selectedBoss,data);

				prevBossModal.value.toggleModal();
			}

			const viewDetails = (_stock)=>{

				Inertia.get(
					'/member/recommendations/boss?stock='+_stock,{},
					{
						// replace: true,
						preserveState: true,
						preserveScroll: true,
						only:['stockDetails']
					}
				)

				recommendationsModal.value.toggleModal();
			}
			
			return{
				recommendationsModal,
				prevBossModal,
				viewDetails,
				selectedBoss,
				selectPrevBoss
			}	

		}
	}
</script>